export default class ElectrocardiogramD{


    /**
     * The stroke width of cell
     */
    CELL_WIDTH = 0.1;

    /**
     * The cell size
     */
    CELL_SIZE = 6.0;

    /**
     * The stroke width of block
     */
    BLOCK_WIDTH = 0.2;

    /**
     * The block size, each block includes 5*5 cells
     */
    BLOCK_SIZE = this.CELL_SIZE * 5;

    /**
     * The stroke width of curve
     */
    CURVE_WIDTH = 1.0;

    /**
     * The number of samples per second 250
     */
    SAMPLING_RATE = 250;

    /**
     * The frequency to update the curve
     */
    FREQUENCY = 25;

    Flag = true;

    ecgRawData;
    /**
     * Electrocardiogram
     * 
     * @param holder
     *           HTML element
     */
    constructor(holder) {
        holder = holder || document.body;
        this.$holder = holder;
        this.$gridColor = 'red';
        this.$strokeColor = 'black';
        this.$dom = holder.ownerDocument;
        this.$cellSize = this.CELL_SIZE;
        this.$samplingRate =this.SAMPLING_RATE;
        this.$canvas = this.$dom.createElement('CANVAS');
        this.$graphics = this.$canvas.getContext('2d');
        this.$canvas.width =  holder.offsetWidth;
        this.$canvas.height =holder.offsetHeight;
        this.$holder.appendChild(this.$canvas);
        this.drawGrid();
    };



        /**
         * Returns the cell size
         * 
         * @return the cell size
         */
        getCellSize(){
            return this.$cellSize;
        };

        /**
         * Returns the block size
         * 
         * @return the block size
         */
        getBlockSize() {
            return 5 * this.$cellSize;
        };

        /**
         * Returns the number of cells per period
         * 
         * @return the number of cells per period
         */
        getCellsPerPeriod() {
            return Math.floor(this.getWidth() / this.getCellSize());
        };

        /**
         * Returns the number of samples per cell
         * 
         * @return the number of samples per cell
         */
        getSamplesPerCell() {
            return 0.04 * this.getSamplingRate();
        };

        /**
         * Returns the number of samples per second
         * 
         * @return the number of samples per second
         */
        getSamplingRate() {
            return this.$samplingRate;
        };

        /**
         * Returns the number of samples per period
         * 
         * @return the number of samples per period
         */
        getSamplesPerPeriod() {
            return Math.floor(0.04 * this.getSamplingRate() * (this.getWidth() / this.getCellSize()))
        };

        /**
         * Returns the width of this electrocardiogram
         * 
         * @return the width of this electrocardiogram
         */
        getWidth() {
            return this.$graphics.canvas.width;
        };

        /**
         * Returns the height of this electrocardiogram
         * 
         * @return the height of this electrocardiogram
         */
        getHeight() {
            return this.$graphics.canvas.height;
        };

        /**
         * Returns the period (seconds) of this electrocardiogram
         * 
         * @return the period of this electrocardiogram
         */
        getPeriod() {
            return 0.04 * this.getWidth() / this.getCellSize();
        };

        /**
         * Clear this electrocardiogram
         */
        clearCell(){
            this.$graphics.clearRect(0, 0, this.getWidth(), this.getHeight());
        };


        clearAll() {
            this.clearCell();
            this.drawGrid();
            this.$graphics.strokeStyle = this.$strokeColor;
        };


        setEcgRawData(data) {
            this.ecgRawData = data;
        };

        setCanvasSize(width, height){
            console.log("canvas size" + width + height);
            this.$canvas.width = width;
            this.$canvas.height = height;
        };

        /**
         * Draw curve with specified data
         */
        drawCurve(data,flag) {
            var i = 0;
            var dt = null;
            var p0 = null;
            var p1 = null;
            var cs = this.getCellSize();
            var sr = this.getSamplingRate();
            var lw = this.$graphics.lineWidth;
            var ss = this.$graphics.strokeStyle;
            var delta = cs / (0.04 * sr);
            var height = this.getHeight();
            // let _ecgRawData=data;
            let _ecgRawData = this.ecgRawData;
            this.clearCell();
            this.drawGrid();
            this.$graphics.strokeStyle = this.$strokeColor;
            this.$graphics.translate(0, height);
            while (i < _ecgRawData.length) {
                if ((p0 = _ecgRawData[i++]))
                    break;
            }
            try{
                // this.$graphics.beginPath();
                // this.$graphics.lineWidth = this.CURVE_WIDTH;
                // this.drawLine(50, -(height/2), 50, -(height));
                // this.drawLine(50, -(height), 100, -(height));
                // this.drawLine(100, -(height), 100, -(height/2));
                // this.$graphics.closePath();
                // this.$graphics.stroke();
                p0.offset = (i - 1) * delta;
                while (i < _ecgRawData.length) {
                    if(flag){
                        _ecgRawData=null;
                        break;
                    }
                    p1 = _ecgRawData[i];
                    p1.offset = i * delta;
                    this.$graphics.beginPath();
                    this.$graphics.lineWidth = this.CURVE_WIDTH;
                    this.drawLine(p0.offset, -(p0.rawdata+height/2), p1.offset, -(p1.rawdata+height/2));
                    this.$graphics.closePath();
                    this.$graphics.stroke();
                    p0 = p1;
                    i++;
                }
            }catch (e) {
                console.log(e);
            }
            this.$graphics.lineWidth = lw;
            this.$graphics.strokeStyle = ss;
            this.$graphics.translate(0, -height);
        };

    /**
     * Draw curve with specified data
     */
    drawCurveOne(data,flag) {
        var i = 0;
        var dt = null;
        var p0 = null;
        var p1 = null;
        var cs = this.getCellSize();
        var sr = this.getSamplingRate();
        var lw = this.$graphics.lineWidth;
        var ss = this.$graphics.strokeStyle;
        var delta = cs / (0.04 * sr);
        var height = this.getHeight();
        // let _ecgRawData=data;
        let _ecgRawData = this.ecgRawData;
        this.clearCell();
        this.drawGrid();
        this.$graphics.strokeStyle = this.$strokeColor;
        this.$graphics.translate(0, height);
        while (i < _ecgRawData.length) {
            if ((p0 = _ecgRawData[i++]))
                break;
        }
        try{
            p0.offset = (i - 1) * delta;
            while (i < _ecgRawData.length) {
                if(flag){
                    _ecgRawData=null;
                    break;
                }
                p1 = _ecgRawData[i];
                p1.offset = i * delta;
                this.$graphics.beginPath();
                this.$graphics.lineWidth = this.CURVE_WIDTH;
                this.drawLine(p0.offset, -(p0.rawdata+height/4), p1.offset, -(p1.rawdata+height/4));
                this.$graphics.closePath();
                this.$graphics.stroke();
                p0 = p1;
                i++;
            }
        }catch (e) {
            console.log(e);
        }
        this.$graphics.lineWidth = lw;
        this.$graphics.strokeStyle = ss;
        this.$graphics.translate(0, -height);
    };

        /**
         * Draw the grid
         */
        drawGrid() {
            var x = 0;
            var y = 0;
            var w = this.getWidth() - 1;
            var h = this.getHeight() - 1;
            var bs = this.getBlockSize();
            var cs = this.getCellSize();
            var lw = this.$graphics.lineWidth;
            var ss = this.$graphics.strokeStyle;

            this.$graphics.strokeStyle = this.$gridColor;

            for (var y = h; y >= 0; y -= cs) {
                this.$graphics.beginPath();
                this.$graphics.lineWidth = ((h - y) % bs)
                        ? this.CELL_WIDTH
                        : this.BLOCK_WIDTH;
                this.drawLine(0, y, w, y);
                this.$graphics.closePath();
                this.$graphics.stroke();
            }

            for (var x = 0; x <= w; x += cs) {
                this.$graphics.beginPath();
                this.$graphics.lineWidth = (x % bs)
                        ? this.CELL_WIDTH
                        : this.BLOCK_WIDTH;
                this.drawLine(x, 0, x, h);
                this.$graphics.closePath();
                this.$graphics.stroke();
            }

            this.$graphics.lineWidth = lw;
            this.$graphics.strokeStyle = ss;
        };

        /**
         * Draw a line from point (x1, y1) to point (x2, y2)
         */
        drawLine(x1, y1, x2, y2) {
            this.$graphics.moveTo(x1, y1);
            this.$graphics.lineTo(x2, y2);
        };


}
